import { useSelector } from "react-redux";

import { SegmentsPageLoader } from "app/pages/segments/segmentsPageLoader";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";
import type { ISegmentsModule } from "app/services/segments/segmentsApiService";

import { usePrimaryCategoryObject } from "../common/hooks/usePrimaryCategoryObject";

// HOC that renders a loader if segments are loading and the selected industry has segments
export const WithSegmentsLoader = (Component) => {
    return function WrappedComponent(props) {
        const categoryObject = usePrimaryCategoryObject();
        const segmentsModule: ISegmentsModule = useSelector((state) => {
            return state.segmentsModule;
        });
        const { segmentsLoading } = segmentsModule;
        if (segmentsLoading && CategoryServiceUtils.hasSegments(categoryObject)) {
            return <SegmentsPageLoader />;
        }
        return <Component {...props} />;
    };
};
